import { createTranslations } from '@npco/common-utils-translations'

export const selectCardTypeFormTranslations = createTranslations({
  expenseCardBadge: 'Free Trial',
  debitCardOptionTitle: 'Debit Card',
  debitCardOptionDesc: 'Spend money from your Zeller Transaction Account.',
  expenseCardOptionTitle: 'Corporate Card',
  expenseCardOptionDesc:
    'Manage team expenses, track spending, and simplify reconciliations with spend limits, recurring budgets, and customisable transaction limits.',
  expenseCardOptionDescFreeTrailEnds:
    'Free until 1 April 2024 (then $9 / Card / Month)',
})
